import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import ClientFormComponent from './client-form.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { FuseSharedModule } from '@fuse/shared.module';
import { ClientService } from './client.service';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { AttributesModule } from '../attributes/attributes.module';
import { ProductService } from '../../pages/product/product.service';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {HttpLoaderFactory} from '../../pages/product/product.model';
import {HttpClient} from '@angular/common/http';


@NgModule({
    declarations: [
        ClientFormComponent
    ],
    imports: [
        CommonModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatTableModule,
        FuseSharedModule,
        AttributesModule,
        TranslateModule
    ],
    exports: [
        ClientFormComponent
    ],
    providers: [
        ClientService,
        ProductService
    ]
})

export class ClientFormModule { }
